export default "__VITE_ASSET__buRGmyu3__"